module.exports = __webpack_public_path__ + "static/media/accordionClosed.ddbfa78f.svg";